import type {Colors, ColorThemeFactoryOptions, ColorThemeID} from './colors';

import {colorThemeFactory} from './colors';
import {font, fontWeight} from './font';
import {size} from './size';
import {statusBar} from './statusBar';

export type {
  Colors,
  ColorThemeID,
  ThemeAndAnyColor,
  ThemeColor,
} from './colors';

export type {ThemeFont, ThemeFontWeight} from './font';

export type {SizeFor, Sizes, ThemeSize} from './size';

export type Theme = {
  color: Colors;
  font: typeof font;
  fontWeight: typeof fontWeight;
  id: ColorThemeID;
  size: typeof size;
  statusBar: typeof statusBar.light;
};

export type Themes = Record<ColorThemeID, Theme>;

export interface WithThemeProp {
  theme: Theme;
}

export const themeFactory = (
  themeId: ColorThemeID,
  options?: ColorThemeFactoryOptions,
): Theme => {
  switch (themeId) {
    case 'dark':
      return {
        color: colorThemeFactory(themeId, options),
        font,
        fontWeight,
        id: 'dark',
        size,
        statusBar: statusBar.dark,
      };
    default:
      return {
        color: colorThemeFactory(themeId, options),
        font,
        fontWeight,
        id: 'light',
        size,
        statusBar: statusBar.light,
      };
  }
};
